import { render, staticRenderFns } from "./PartnersBanner.vue?vue&type=template&id=2751cef2&scoped=true&"
import script from "./PartnersBanner.vue?vue&type=script&lang=js&"
export * from "./PartnersBanner.vue?vue&type=script&lang=js&"
import style0 from "./PartnersBanner.vue?vue&type=style&index=0&id=2751cef2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2751cef2",
  null
  
)

export default component.exports